import React from "react";
import img from "../../assets/team/team7.png";
function Vanessa() {
  return (
    <div className="bg-[#E8FCFF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col lg:flex-row items-center px-10 w-full gap-10">
        <div className="flex justify-center flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Michelle Parsons
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            BA Psychology
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Michelle has been working with children since 2011. As a Behavior Consultant, she supports individuals across all ages.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Michelle holds a Bachelor of Arts degree in Psychology from Kwantlen Polytechnic University and an advanced 
            certificate in disability and applied behavior analysis from Douglas College.
          </p>
          {/* <p className="font-normal text-lightGreen-500 text-lg lg:max-w-[680px]">
            In <span className="font-mono">2021</span> she joined KCART where
            she is a Research Assistant.
          </p> */}
        </div>
        <img src={img} alt="" />
      </div>
  </div>
  );
}

export default Vanessa;
